<template>
  <div class="MonthZhiChi">
    <!-- <div v-for="(item, ind) in listArr">
      <div>{{item}}</div>
    </div>-->
    <div class="kaoheForm">
      <div class="item">
        <label for="quarter_now">当前季度 :</label>
        <input id="quarter_now" disabled v-model="zhichiForm.QUARTER_NOW" />
      </div>
    </div>
    <CorssTable :tableConfig="tableConfig"></CorssTable>
  </div>
</template>
<script>
import axios from "axios";
import CorssTable from "@/__component__/CorssTable"
export default {
  components: {
    CorssTable
  },
  data() {
    return {
      zhichiForm: {
        QUARTER_NOW: '',  //当前季度
      },
      tableConfig: {
        width: {
          table_width: '100%',
          head_width: 100,
        },
        columns: [
          {
            title: '年份',
            key: 'YEAR',
          },
          {
            title: '月份',
            key: 'MONTH',
          },
          {
            title: '已支持',
            key: 'SUPPORT_STATUS',
          },
          {
            title: '本次计划支持',
            key: 'SUPPORT_PLAN',
          },
        ],
        data: []
      }
    };
  },
  mounted() {
    this.getInformation();
  },

  methods: {
    getInformation() {
      const { tableName, tableId, itemId } = this.$route.params;
      this.$network.post('/p/cs/scrm/selectAssessInfoOrder', { id: itemId == 'New' ? -1 : itemId }).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          this.zhichiForm.QUARTER_NOW = res.data.data.cl_c_store_effect_assess_month_info[0].QUARTER_NOW;
          this.yinse(res.data.data.cl_c_store_effect_assess_month_info);
          this.tableConfig.data = res.data.data.cl_c_store_effect_assess_month_info;
        }

      });
    },

    yinse(res) {
      res.map(item => {
        item.MONTH = item.MONTH + '月'; //月份映射
        if (item.SUPPORT_PLAN == 1) {
          item.SUPPORT_PLAN = '√';
        } else {
          item.SUPPORT_PLAN = 'x';
        };

        if (item.SUPPORT_STATUS == 1) {
          item.SUPPORT_STATUS = '√';
        } else {
          item.SUPPORT_STATUS = 'x';
        }

      })
    }
  }
};
</script>
<style lang="less">
.MonthZhiChi {
  .kaoheForm {
    display: flex;
    margin: 10px 0;
    padding: 0 10px;
    .item {
      padding: 0 5px;
      display: flex;
      label {
        display: inline-block;
        vertical-align: middle;
        white-space: nowrap;
        line-height: 26px;
      }
      input {
        height: 26px;
        padding: 0 5px;
        margin-left: 3px;
      }
      input[disabled] {
        background-color: #f4f4f4;
        border: 1px solid #d8d8d8;
      }
    }
  }
}
</style>